"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var common_1 = require("@angular/common");
var overlay_1 = require("@ngui/overlay");
var popup_component_1 = require("./popup.component");
exports.NguiPopupComponent = popup_component_1.NguiPopupComponent;
var message_popup_component_1 = require("./message-popup.component");
exports.NguiMessagePopupComponent = message_popup_component_1.NguiMessagePopupComponent;
var NguiPopupModule = (function () {
    function NguiPopupModule() {
    }
    return NguiPopupModule;
}());
NguiPopupModule = __decorate([
    core_1.NgModule({
        imports: [common_1.CommonModule, forms_1.FormsModule, overlay_1.NguiOverlayModule],
        declarations: [message_popup_component_1.NguiMessagePopupComponent, popup_component_1.NguiPopupComponent],
        exports: [message_popup_component_1.NguiMessagePopupComponent, popup_component_1.NguiPopupComponent],
        entryComponents: [message_popup_component_1.NguiMessagePopupComponent]
    }),
    __metadata("design:paramtypes", [])
], NguiPopupModule);
exports.NguiPopupModule = NguiPopupModule;
//# sourceMappingURL=popup.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngui/popup/dist/popup.module.js
// module id = 553
// module chunks = 4